<template>
  <div>
    <transition name="modal">       
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container w3-modal-content"  style="max-width: 350px;" @click.stop>
            <header class="w3-container modal-wrapper">              
              <span @click="$emit('close')" class="w3-button w3-display-topright">&times;</span>
              <h2 class="texto-vermelho titulo">Coletar Usuário Santri</h2>
            </header>            
            <div class="w3-container" style="max-height: calc(100vh - 320px)">             
              <input 
                type="text" 
                id="nome_usuario_santri" 
                ref="nome_usuario_santri" 
                class="w3-input w3-border w3-round" 
                style="margin-bottom:5px" 
                v-model="nome_usuario_santri" 
                v-on:keyup="nome_usuario_santri = nome_usuario_santri.toUpperCase()" 
                placeholder="Usuário santri" 
                required autofocus/>

              <input 
                type="password" 
                id="senha_usuario_santri"
                class="w3-input w3-border w3-round" 
                v-model="senha_usuario_santri" 
                v-on:keyup="senha_usuario_santri = senha_usuario_santri.toUpperCase()" 
                placeholder="Senha" 
                @keydown.enter="ok()" 
                required/>

            </div>  
            <div class="w3-container">
              <div class="w3-center">
                <button class="w3-button w3-theme" style="margin: auto; margin-top: 10px; margin-bottom:10px" v-on:click="ok()">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import toastr from 'toastr'

  export default {
    name: 'ModalColetarUsuarioSantri',    
    props: ['nome_usuario_santri, senha_usuario_santri'],
    data() {
      return {
        api: process.env.API,
        nome_usuario_santri: '',
        senha_usuario_santri: ''
      }
    },    
    created(){
      this.$nextTick(() => this.$refs.nome_usuario_santri.focus())
    },   
    methods: {
    ok: function(){
       if (this.usuario_santri == ""){
          toastr.error('Usuário não informado!');
          return;
        }

        if (this.senha_usuario_santri == ""){
          toastr.error('Senha não informada!');
          return;
        }

        let objeto = {
          nome_usuario_santri: this.nome_usuario_santri,
          senha_usuario_santri: this.senha_usuario_santri
        };

        this.$emit('setar_usuario_santri', objeto);
      
      this.$emit('close');
      
    }   
  }
}  
</script>
<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  @media (min-width: 993px){
    .modal-container {
        width: 1010px;
    }
  }
  @media (max-width: 768px){
    .modal-container {
        width: 600px;
    }
  }
  @media (max-width: 605px){
    .modal-container {
        width: 320px !important;
        
    }
    .container-items {
      max-height: 230px !important;
    }
  }  
  .modal-container {
    border-radius: 12px ;
    margin: auto;
    height: auto;
    padding: 10px 10px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    animation: animatezoom 0.6s;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  button {
      background: #9c1d1c;
      color: white;
      padding: 10px;
      border: 0 !important
  }
</style>


// WEBPACK FOOTER //
// src/components/ColetarUsuarioSantri.vue